<ng-container screenAnalytics="mission-overlap-view">
    <div class="modal-header no-icon">
        <h3 class="modal-title">Conflicting Mission</h3>
        <button
            type="button"
            aria-label="Close"
            class="close"
            (click)="onCancel()"
        >
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body max-height">
        <div class="col-md-6">
            <div class="bottom-buffer">
                <label class="display-label">Mission Name</label>
                <div>{{ overlappingMission.name }}</div>
            </div>
            <div class="bottom-buffer">
                <label class="display-label">Organisation</label>
                <div>{{ overlappingMission.organisationName }}</div>
            </div>
            <div class="bottom-buffer">
                <label class="display-label">Status</label>
                <div>{{ overlappingMission.status }}</div>
            </div>
            <div class="bottom-buffer">
                <label class="display-label">Mission Date</label>
                <div>
                    {{ overlappingMission.missionDate | formatDateTime }}
                </div>
            </div>
            <div class="bottom-buffer">
                <label class="display-label">Estimated Duration</label>
                <div>
                    {{
                        overlappingMission.missionEstimatedTime / 60
                            | number: '1.0-0'
                    }}
                    minutes
                </div>
            </div>
            <div class="bottom-buffer">
                <label class="display-label">Maximum Height (ft AGL)</label>
                <div>{{ overlappingMission.maximumHeight }}</div>
            </div>
            <div class="bottom-buffer">
                <label class="display-label">Visual Line of Sight</label>
                <div>{{ overlappingMission.visualLineOfSight }}</div>
            </div>
            <div class="bottom-buffer">
                <label class="display-label">Point of Contact</label>
                <div>{{ overlappingMission.pointOfContact }}
                                :
                                {{ overlappingMission.pointOfContactInformation }}</div>
            </div>
        </div>
        <div class="col-md-6" style="height: 100%">
            <flyfreely-map
                #map
                [organisationId]="organisationId"
                [features]="allFeatures"
                [requireCtrlToZoom]="true"
                style="width: 100%; height: 100%"
                (featuresLoaded)="map.zoomToAllFeatures(true)"
            >
            </flyfreely-map>
        </div>
    </div>
    <div class="modal-footer">
        <ng-container *ngIf="!isInformational">
            <p
                *ngIf="!isAcknowledged"
                class="text-danger"
                style="display: inline-block"
            >
                You have not acknowledged this conflicting mission
            </p>
            <button
                type="button"
                class="btn btn-primary relative"
                [disabled]="isAcknowledged || working"
                (click)="onAcknowledge()"
            >
                {{ isAcknowledged ? 'Acknowledged' : 'Acknowledge' }}
                <span
                    class="overlay"
                    [tooltip]="
                        isAcknowledged
                            ? 'You have already acknowledged this conflicting mission'
                            : 'Acknowledge this conflicting mission'
                    "
                    placement="top"
                ></span>
            </button>
        </ng-container>
    </div>
</ng-container>
